import React from 'react';
import Layout from '../components/Layouts/Layout';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { ASSET_URL } from '../config/config';

const allBlog = [
    {
        id: 1,
        image: ASSET_URL+'assets/images/blog/1.webp',
        heading: 'EV Charging Business Is Good For Every Business',
        desc: 'As more and more people in India are realizing the dire consequences of air pollution and opting to adopt an eco-friendly approach to transport and other aspects of their lives, electric vehicles have taken the centre stage to start this&nbsp;green revolution.'
    },
    {
        id: 2,
        image: ASSET_URL+'assets/images/blog/2.webp',
        heading: 'EV Charging Infrastructure The Need Of The Hour',
        desc: 'If there ever was a country that requires a broad EV charging network, it’s India. Thirty -five of the top fifty most polluted cities in the world in India. And the need for EVs and consequent EV charging stations has never been more.'
    },
    {
        id: 3,
        image: ASSET_URL+'assets/images/blog/3.webp',
        heading: 'EV Charging Powered by Renewable Sources',
        desc: 'India is a country that is rapidly moving towards sustainable development, with a target of reducing carbon emissions and pollution. One of the key areas where India has been making significant progress is in the adoption of electric vehicles.'
    },
    {
        id: 4,
        image: ASSET_URL+'assets/images/blog/4.webp',
        heading: 'Benefits of Installing EV Charging Stations in India',
        desc: 'To reach its ambitious target of 30% EV penetration by 2030, the Indian government has set tall goals for the switch to EVs over the coming years. For this, a complete national network of EV charging stations must be built.'
    }
]

const Blog = () => {
    return (
        <>
            <Layout>
                <section className='blog-header-bg header-bg' style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), url(${ASSET_URL}assets/images/sliders/blog.webp)`}}>
                    <Container>
                        <Row>
                            <Col sm={12} lg={5}>
                                <div className="title">
                                    <h1 className="title-heading fs-3 mb-1">
                                        <span>Blog</span></h1>
                                    <p className="title-desc">Industry information, just an interesting read away</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <section className="blog text-center" id="blog">
                    <div className="container">
                        <div className="row d-flex justify-content-center gy-4">
                            { allBlog && allBlog.map((item, index) => 
                                <div className="col-12 col-md-6 col-lg-4" key={index}>
                                    <div className="card">
                                        <div className="bg-image hover-overlay ripple p-1" data-mdb-ripple-color="light">
                                            <img src={item.image} className="img-fluid w-100" alt="Blog" />
                                            <Link to="/">
                                                <div className="mask" style={{ background: 'rgba(251, 251, 251, 0.15)' }}></div>
                                            </Link>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">{item.heading}</h5>
                                            <p className="card-text">{item.desc}</p>
                                            <Link to={`/blog/${item.heading.toLowerCase().replace(/ /g, "-")}`} className="btn btn-danger text-decoration-none">Read More</Link>
                                        </div>
                                    </div>
                                </div> 
                            ) }
                        </div>
                    </div>
                </section>
            </Layout>
        </>
    )
}

export default Blog